<template>
  <div class="bq-product-zndz">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <p class="title-desc">
      AI导诊模型，根据患者病情描述为患者推荐合适的挂号科室，减少患者挂错号、医疗资源浪费等问题，达到帮助患者精确匹配到合适的医疗资源，实现医院资源的合理分配。
      <br />
      <br />
      智能导诊通过海量文献的机器学习，可覆盖大部分常见疾病及科室，形成智能人机交互模型。模型具有自我学习及纠错能力，可不断提升准确度，同时支持针对医院具体情况，进行本地化模型适配。
    </p>
    <div class="zndz-descs">
      <div class="descs-top">
        <div>
          用户
        </div>
        <img
          :src="rightArrow"
          alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
        />
        <div>
          会话接口
        </div>
        <img
          :src="rightArrow"
          alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
        />
        <div>语义分析<br />（模型）</div>
        <img
          :src="rightArrow"
          alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
        />
        <div>
          推荐科室
        </div>
        <img
          :src="rightArrow"
          alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
        />
        <div>
          挂号接口
        </div>
        <img
          :src="rightArrow"
          alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
        />
        <div>
          挂号平台
        </div>
      </div>
      <div class="descs-mid">
        <div class="mid-left">
          <div class="mid-img">
            <span>训练</span>
            <img
              src="https://img.alicdn.com/tfs/TB14OeoDHr1gK0jSZR0XXbP8XXa-15-35.png"
              alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
            />
          </div>
          <div class="mid-text">语料库<br />（描述-确诊）</div>
        </div>
        <div class="mid-right">
          <img
            src="https://img.alicdn.com/tfs/TB1xxapDQL0gK0jSZFAXXcA9pXa-397-70.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
          <span>补充（数据闭环）</span>
        </div>
      </div>
      <div class="descs-bot">
        <span>清洗/标注</span>
        <img
          src="https://img.alicdn.com/tfs/TB1YvCkDGL7gK0jSZFBXXXZZpXa-316-96.png"
          alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
        />
      </div>
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div class="zndz-adv">
      <InfoBox
        :col="3"
        :itemObj="item"
        v-for="item in datalist"
        :key="item.advTitles"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'zndz',
  data() {
    return {
      rightArrow:
        'https://img.alicdn.com/tfs/TB1VDuoDUY1gK0jSZFMXXaWcVXa-36-16.png',
      datalist: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1WIyhFYj1gK0jSZFuXXcrHpXa-96-96.png',
          advTitles: '海量文献',
          advDesc:
            '智能导诊通过海量文献的机器学习，可覆盖大部分常见疾病及科室，形成智能人机交互模型；',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1IIGfFYY1gK0jSZTEXXXDQVXa-96-96.png',
          advTitles: '人机交互',
          advDesc:
            '基于智能人机交互模型，交互轮数更少，用户体验更流畅，同时保证科室精准命中率；',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1KA5bF7P2gK0jSZPxXXacQpXa-96-96.png',
          advTitles: '自我学习',
          advDesc:
            '模型具有自我学习及纠错能力，可不断提升准确度。同时支持针对医院具体情况，进行本地化模型适配。',
        },
      ],
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
.bq-product-zndz {
  .title-desc {
    color: #333;
    font-size: 18px;
  }

  .zndz-descs {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 65px 76px;

    .descs-top {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 109px;
        height: 44px;
        border-radius: 6px;
        border: 2px solid rgba(21, 43, 145, 1);
        color: #152b91;
        font-size: 14px;

        &:first-child {
          width: 55px;
          height: 54px;
          border-radius: 50%;
        }
      }

      img {
        width: 36px;
        height: 16px;
      }
    }

    .descs-mid {
      display: flex;
      position: relative;
      left: 233px;

      .mid-left {
        .mid-img {
          position: relative;
          left: -13px;
          text-align: center;
          span {
            position: relative;
            left: -10px;
          }
        }
        .mid-text {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 109px;
          height: 44px;
          border-radius: 6px;
          border: 2px solid rgba(21, 43, 145, 1);
          color: #152b91;
          font-size: 14px;
          text-align: center;
        }
      }

      .mid-right {
        display: flex;
        flex-direction: column;

        span {
          position: relative;
          left: 134px;
        }
      }
    }

    .descs-bot {
      position: relative;
      left: 130px;

      span {
        position: absolute;
        left: 210px;
      }
    }
  }

  .zndz-adv {
    display: flex;
    justify-content: space-between;
    .bq-infobox {
      width: 252px !important;
    }
  }

  /deep/ .bq-infobox {
    p {
      font-size: 18px;
    }
  }

  /deep/ .header-title {
    margin-bottom: 60px;
    padding-bottom: 0;
  }
}
</style>
